export const SET_ARCHIVE = 'PARTNER/ARCHIVE/SET_ARCHIVE'
export const SET_ARCHIVES = 'PARTNER/ARCHIVE/SET_ARCHIVES'
